import React from 'react';
import { Box, Text, Badge } from '@chakra-ui/react';
import { ICsvAthleteMatch } from '../../../../endpoints/sessions';

interface AthleteMatcherTableProps {
  matches: ICsvAthleteMatch[];
  roster: { _id: string; firstName: string; lastName: string }[];
  assignments: Record<string, string | null>;
  onAssignmentChange: (csvValue: string, athleteId: string | null) => void;
}

/**
 * Tabella matching atleti CSV → roster (Step 4 wizard).
 */
export const AthleteMatcherTable: React.FC<AthleteMatcherTableProps> = ({
  matches,
  roster,
  assignments,
  onAssignmentChange,
}) => {
  const matchTypeBadge = {
    exact: { color: 'green', label: 'ESATTO' },
    alias: { color: 'green', label: 'ALIAS' },
    fuzzy: { color: 'orange', label: 'FUZZY (conferma)' },
    none: { color: 'red', label: 'NON MATCHATO' },
  };

  return (
    <Box overflowX="auto">
      <Box
        as="table"
        width="100%"
        style={{ borderCollapse: 'collapse', fontSize: '13px' }}
      >
        <thead>
          <tr style={{ background: '#f1f5f9' }}>
            <th style={{ padding: 8, textAlign: 'left' }}>Valore CSV</th>
            <th style={{ padding: 8, textAlign: 'center' }}>Occorrenze</th>
            <th style={{ padding: 8, textAlign: 'left' }}>Match</th>
            <th style={{ padding: 8, textAlign: 'left', minWidth: 280 }}>
              Atleta roster
            </th>
          </tr>
        </thead>
        <tbody>
          {matches.map((m) => {
            const badge = matchTypeBadge[m.matchType];
            const currentAssignment =
              assignments[m.csvValue] !== undefined
                ? assignments[m.csvValue]
                : m.matchedAthleteId ?? null;

            return (
              <tr
                key={m.csvValue}
                style={{ borderBottom: '1px solid #e2e8f0' }}
              >
                <td style={{ padding: 8 }}>
                  <Text fontFamily="mono">{m.csvValue}</Text>
                </td>
                <td style={{ padding: 8, textAlign: 'center' }}>
                  <Badge>{m.occurrences} righe</Badge>
                </td>
                <td style={{ padding: 8 }}>
                  <Badge colorPalette={badge.color}>{badge.label}</Badge>
                  {m.matchedAthleteName && (
                    <Text fontSize="11px" color="gray.500" mt={1}>
                      {m.matchedAthleteName}
                    </Text>
                  )}
                </td>
                <td style={{ padding: 8 }}>
                  <select
                    value={currentAssignment ?? ''}
                    onChange={(e) =>
                      onAssignmentChange(
                        m.csvValue,
                        e.target.value || null,
                      )
                    }
                    style={{
                      width: '100%',
                      padding: '6px 8px',
                      borderRadius: 6,
                      border: '1px solid #cbd5e1',
                      fontSize: 13,
                      background: 'var(--c-card-bg)',
                    }}
                  >
                    <option value="">— ignora riga —</option>
                    {roster.map((r) => (
                      <option key={r._id} value={r._id}>
                        {r.firstName} {r.lastName}
                      </option>
                    ))}
                  </select>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Box>
    </Box>
  );
};
